
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenCountyCoverage {

    id: number;
    abbreviation: string;
    county: string;
    countyId: number;
    coveredCustomers: number;
    fipsCode: string;
    percentage: number;
    state: string;
    stateFips: string;
    totalCustomers: number;
    year: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genCountyCoverage: GenCountyCoverage);
    constructor( id: number );

    constructor( input?: GenCountyCoverage|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.abbreviation = input.abbreviation; // string [string]
            this.county = input.county; // string [string]
            this.countyId = input.countyId; // int [number]
            this.coveredCustomers = input.coveredCustomers; // int [number]
            this.fipsCode = input.fipsCode; // string [string]
            this.percentage = input.percentage; // float [number]
            this.state = input.state; // string [string]
            this.stateFips = input.stateFips; // string [string]
            this.totalCustomers = input.totalCustomers; // int [number]
            this.year = input.year; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenCountyCoverage[] {
        if (arr && arr.map) {
          return arr.map(a => new GenCountyCoverage(a));
        } else {
          return [];
        }
    }
}

